export default __webpack_public_path__ + "static/media/mirakl.4baf838a.png";